// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3L1bZ","requiredAsterisk":"Info_requiredAsterisk__2BZRU"};